import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModalHeader, CModalTitle } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import DisplayNoteHpiQuestion from '../../components/shared/DisplayNoteHpiQuestion'
import SaveExtra from '../../services/general/saveExtraData.api'
import Graytextarea from '../../components/Graytextarea'
import { FilePlus2, LetterTextIcon, Plus } from 'lucide-react'
import Select from 'react-select'
import { previousDay } from 'date-fns'
import { backgroundColor, fontSize } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items'
const ProviderHpiQuestions = ({ diagnosis, showDataIfNoteIsFollowUp, saveTreatsShell, addDiagnosisIdsToNote, patientID = '', patientData, noteID, isAllotedToProvider, patientDiagnosis, noteStructureRef }) => {
  const [fetchingQuestions, setFetchingQuestions] = useState(false)
  const [isPageLoading, setIsPatientPageLoading] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [subjective, setSubjective] = useState([])
  const [visible, setVisible] = useState(false)
  const [freeTypes, setFreeTypes] = useState({})
  const [questionAnswers, setQuestionAnswers] = useState({})
  const [freetypeModal, setFreetypeModal] = useState(false)
  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  const [tempFreeTypeText, setTempFreeTypeText] = useState('')

  const [selectedDiagnosiToAddFreeTypeRemarks, setSelectedDiagnosiToAddFreeTypeRemarks] = useState('')
  const [freeTypeRemarksText, setFreeTypeRemarksText] = useState('')
  const [questionsWithDiagnosis, setQuestionsWithDiagnosis] = useState({})
  const [patientFinalNoteHpi, setPatientFinalNoteHpi] = useState({})
  const [saving, setSaving] = useState(false)

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)
  }

  useEffect(() => {
    getData()
  }, [])

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const getQuestionForDiagnosis = async (hpiData = null) => {
    setFetchingQuestions(true)

    try {
      let diagnosisData = await GetDiagnosisData('')
      diagnosisData = JSON.parse(diagnosisData?.d)?.Data || []

      const currentHpiData = hpiData || patientFinalNoteHpi

      const tempIds = noteStructureRef.current?.metadata?.tempIds || []
      const followupIds = noteStructureRef.current?.metadata?.diagnosisIds || []

      const findDiagnosisIids = diagnosisData.filter((item) => patientDiagnosis?.includes(item?.Name))

      const structured = {}
      const freeTypeAllDiagnosis = {}

      if (findDiagnosisIids?.length > 0) {
        await Promise.all(
          findDiagnosisIids.map(async (diagnos) => {
            let questionType = 'HPI'

            if (patientData.Status === 'NewPatient') {
              if (tempIds.includes(diagnos.id) || followupIds.includes(diagnos.id)) {
                questionType = 'HPI'
              }
            } else if (patientData.Status === 'Follow Up') {
              if (tempIds.includes(diagnos.id)) {
                questionType = 'HPI'
              } else if (followupIds.includes(diagnos.id)) {
                questionType = 'followup'
              }
            }

            let data = await SaveQuestionProvider('GET', '', questionType, diagnos.id, '')

            data = JSON.parse(data?.d)?.Data || []

            const questions = data
              .map((q) => {
                try {
                  return JSON.parse(q.questionData)
                } catch (e) {
                  return []
                }
              })
              .flat()

            const answered = Array.isArray(currentHpiData?.[diagnos.Name]) ? currentHpiData[diagnos.Name] : []

            // if (answered.length > 0 && answered[0]?.freewayRemark) {
            //   freeTypeAllDiagnosis[diagnos?.Name] = answered[0]?.freewayRemark || freeTypes[diagnos?.Name] || ''
            // }
            const remark = answered.length > 0 && answered[0]?.freewayRemark ? answered[0].freewayRemark : freeTypes[diagnos?.Name] || ''

            freeTypeAllDiagnosis[diagnos?.Name] = remark

            const updateQuestionsWithAnswer = (questionsList, parentLabel = '') => {
              return questionsList.map((q) => {
                const match = answered.find((a) => a.label === q.label && a.id == q.id)
                const updatedQuestion = {
                  ...q,
                  // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                  historyOfDiagnosis: q?.historyOfDiagnosis || false,
                  freewayRemark: q.freewayRemark || '',
                  answer: match?.answer || '',
                  freeType: match?.freeType || '',
                  parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                }

                // If selected option has linkedQuestion, update it too
                if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                  updatedQuestion.options = updatedQuestion.options.map((opt) => {
                    if (opt.label === updatedQuestion.answer && opt.linkedQuestion?.length > 0) {
                      return {
                        ...opt,
                        linkedQuestion: updateQuestionsWithAnswer(opt.linkedQuestion, updatedQuestion.label),
                      }
                    }
                    return opt
                  })
                }

                return updatedQuestion
              })
            }

            const mergedQuestions = updateQuestionsWithAnswer(questions)
            structured[diagnos.Name] = mergedQuestions
          }),
        )
      }

      setFreeTypes(freeTypeAllDiagnosis)
      // setQuestionsWithDiagnosis(structured)
      setQuestionsWithDiagnosis((prev) => {
        const merged = { ...prev }

        Object.entries(structured).forEach(([diagnosisName, questions]) => {
          if (!merged[diagnosisName]) {
            merged[diagnosisName] = questions
          }
        })

        return merged
      })
    } catch (error) {
      console.error('Error in getQuestionForDiagnosis:', error)
    } finally {
      setFetchingQuestions(false)
    }
  }

  const getQuestionForNewlyDiagnosis = async (selectedDiagnosisIds) => {
    // setFetchingQuestions(true);

    try {
      let diagnosisData = await GetDiagnosisData('')
      diagnosisData = JSON.parse(diagnosisData?.d)?.Data || []

      const tempIds = noteStructureRef.current?.metadata?.tempIds || []
      const followupIds = noteStructureRef.current?.metadata?.diagnosisIds || []

      // Filter diagnosis based on the selected IDs
      const findDiagnosisIids = diagnosisData.filter((item) => selectedDiagnosisIds.includes(item.id))

      const newQuestionsData = {}

      if (findDiagnosisIids?.length > 0) {
        await Promise.all(
          findDiagnosisIids.map(async (diagnos) => {
            let questionType = 'HPI'

            // if (patientData.Status === 'NewPatient') {
            //   if (tempIds.includes(diagnos.id) || followupIds.includes(diagnos.id)) {
            //     questionType = 'HPI';
            //   }
            // } else if (patientData.Status === 'Follow Up') {
            //   if (tempIds.includes(diagnos.id)) {
            //     questionType = 'HPI';
            //   } else if (followupIds.includes(diagnos.id)) {
            //     questionType = 'followup';
            //   }
            // }

            let data = await SaveQuestionProvider('GET', '', questionType, diagnos.id, '')
            data = JSON.parse(data?.d)?.Data || []

            const questions = data
              .map((q) => {
                try {
                  return JSON.parse(q.questionData)
                } catch (e) {
                  return []
                }
              })
              .flat()

            // Get existing answers for this diagnosis if any
            const answered = Array.isArray(patientFinalNoteHpi?.[diagnos.Name]) ? patientFinalNoteHpi[diagnos.Name] : []

            const updateQuestionsWithAnswer = (questionsList, parentLabel = '') => {
              return questionsList.map((q) => {
                const match = answered.find((a) => a.label === q.label && a.id == q.id)
                const updatedQuestion = {
                  ...q,
                  // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                  historyOfDiagnosis: q?.historyOfDiagnosis || false,
                  freewayRemark: q.freewayRemark || '',
                  answer: match?.answer || '',
                  freeType: match?.freeType || '',
                  parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                }

                // Handle linked questions for options
                if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                  updatedQuestion.options = updatedQuestion.options.map((opt) => {
                    if (opt.label === updatedQuestion.answer && opt.linkedQuestion?.length > 0) {
                      return {
                        ...opt,
                        linkedQuestion: updateQuestionsWithAnswer(opt.linkedQuestion, updatedQuestion.label),
                      }
                    }
                    return opt
                  })
                }

                return updatedQuestion
              })
            }

            const mergedQuestions = updateQuestionsWithAnswer(questions)
            newQuestionsData[diagnos.Name] = mergedQuestions
          }),
        )
      }

      // Merge new questions with existing questions
      setQuestionsWithDiagnosis((prevData) => ({
        ...prevData,
        ...newQuestionsData,
      }))
    } catch (error) {
      console.error('Error in getQuestionForNewlyDiagnosis:', error)
    } finally {
      // setFetchingQuestions(false);
    }
  }

  const fetchPatientFinalNoteDetails = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)

      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)

      setSubjective(result[patientID])

      try {
        const hpiData = result?.[patientID]?.[noteID]?.HPI || {}
        const newFreeTypeTextFetched = result?.[patientID]?.[noteID]?.newFreeTypeText || ''
        if (newFreeTypeTextFetched) {
          setNewFreeTypeText(newFreeTypeTextFetched || '')
          setTempFreeTypeText(newFreeTypeTextFetched || '')
        }
        setPatientFinalNoteHpi(hpiData)
        // await getQuestionForDiagnosis(hpiData) //it will reload the data loading set, when new diagnosis added ig isssue
        return hpiData
      } catch (error) {
        console.error('Error setting patient HPI:', error)
        setPatientFinalNoteHpi({})
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const fetchHpiAndQuestions = async () => {
      const hpidata = await fetchPatientFinalNoteDetails()
      await getQuestionForDiagnosis(hpidata)
    }
    fetchHpiAndQuestions()
  }, [patientDiagnosis])

  const collectAllAnsweredQuestionsFromMerged = (questions, parentContext = null, onlyWithHistoryOfDiagnosis = false) => {
    const result = []

    for (const q of questions) {
      const { answer, freeType, label, options = [], id } = q
      const hasAnswer = Array?.isArray(answer) ? answer?.join(',')?.trim() : answer?.trim()

      const hasFreeType = freeType?.trim()
      // Add this question if it has answer or freeType
      // if (hasAnswer || hasFreeType) {
      //     result.push({
      //         label,
      //         answer,
      //         freeType,
      //         freewayRemark: q.freewayRemark || '',
      //         historyOfDiagnosis: q.historyOfDiagnosis || undefined,
      //         parentQuestion: parentContext
      //             ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
      //             : undefined,
      //     });
      // }
      // Add question if it has an answer, freeType, or isOptionForFreeType is true
      const shouldInclude = (hasAnswer || hasFreeType || q?.isOptionForFreeType || q?.freewayRemark) && (!onlyWithHistoryOfDiagnosis || q?.historyOfDiagnosis === true)

      if (shouldInclude) {
        result.push({
          id,
          label,
          answer,
          freeType,
          freewayRemark: q.freewayRemark || '',
          historyOfDiagnosis: q.historyOfDiagnosis || undefined,
          isOptionForFreeType: q?.isOptionForFreeType || false, // keep this in the result
          parentQuestion: parentContext ? `${parentContext.label} - ${parentContext.selectedOptionLabel}` : undefined,
        })
      }

      // Now check options for linked questions
      for (const opt of options) {
        if (opt.linkedQuestion && opt.linkedQuestion.length > 0) {
          const nestedContext = {
            label: answer,
            selectedOptionLabel: opt.label,
          }
          const nestedResults = collectAllAnsweredQuestionsFromMerged(opt.linkedQuestion, nestedContext)
          result.push(...nestedResults)
        }
      }
    }

    return result
  }

  const handleSubmit2 = async () => {
    setSaving(true)

    const buildHPIObject = () => {
      return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
        const collected = collectAllAnsweredQuestionsFromMerged(questions, null, false)
        if (collected.length > 0) {
          acc[key] = collected
        }
        return acc
      }, {})
    }

    if (parseInt(noteID) === 0) {
      const buildNoteStructureHistoryofDiagnosis = () => {
        return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
          const collected = collectAllAnsweredQuestionsFromMerged(questions, null, true)
          const filteredQuestions = collected.map((item) => ({
            label: item.label,
            answer: item.answer,
            freeType: item.freeType,
            parentQuestion: item.parentQuestion,
            originalQuestion: item,
            id: item.id,
          }))

          if (filteredQuestions.length > 0) {
            acc[key] = filteredQuestions
          }

          return acc
        }, {})
      }

      const finalHpiForNoteIDZero = buildNoteStructureHistoryofDiagnosis()
      if (Object.keys(finalHpiForNoteIDZero).length > 0) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          historyOfDiagnosis: finalHpiForNoteIDZero,
        }
        await saveTreatsShell(false)
      }
    }
    const finalHpi = buildHPIObject()
    if (Object.keys(finalHpi).length === 0) {
      console.warn('No diagnosis has any answered data. Nothing to save.')
      // return;
    }

    let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
    let allData = JSON.parse(data?.d)
    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        Id: item?.Id,
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    const latestPatientHPISecondTimeNoteWithSubjective = result[patientID]

    if (latestPatientHPISecondTimeNoteWithSubjective) {
      const finalHpiStructure = {
        [patientID]: {
          [noteID]: {
            HPI: finalHpi,
            medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
            data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
            newFreeTypeText: newFreeTypeText || '',
          },
        },
      }

      await SaveExtra('UPDATE', 'PatientHPI', JSON.stringify(finalHpiStructure), result?.Id)
      setVisible(false)
      const hpidata = await fetchPatientFinalNoteDetails()
      await getQuestionForDiagnosis(hpidata)
    } else {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)
      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          Id: item?.Id,
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      if (patientID && Number(noteID)) {
        const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
        const latestPatientHPISecondTimeNoteWithSubjective = result[patientID]

        const finalHpiStructure = {
          [patientID]: {
            [noteID]: {
              HPI: finalHpi,
              medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
              data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
              newFreeTypeText: newFreeTypeText || '',
            },
          },
        }

        await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
        setVisible(false)
        const hpidata = await fetchPatientFinalNoteDetails()
        await getQuestionForDiagnosis(hpidata)
      }
    }
    setSaving(false)
  }

  const [isAddingDiagnosis, setIsAddingDiagnosis] = useState(false)
  const handleAddDiagnosis = async () => {
    setIsAddingDiagnosis(true)
    if (!selectedDiagnosis || selectedDiagnosis.length === 0) {
      console.warn('No diagnosis selected. Please select at least one diagnosis.')
      return
    }
    await addDiagnosisIdsToNote(selectedDiagnosis.map((item) => item.value))
    setSelectedDiagnosis(null)
    await fetchPatientFinalNoteDetails()
    await getQuestionForNewlyDiagnosis(selectedDiagnosis.map((item) => item.value))
    setVisible(false)
    setIsAddingDiagnosis(false)
  }

  const updateAnswerById = (questions, targetId, updater) => {
    return questions.map((q) => {
      if (q.id === targetId) {
        const updated = updater(q)
        return updated
      } else if (q.options?.some((opt) => opt.linkedQuestion?.length)) {
        let selectedOptions = []
        if (q.isMultiple) {
          const answerArray = q.answer ? q.answer.split(',').map((v) => v.trim()) : []
          selectedOptions = q.options.filter((opt) => answerArray.includes(opt.label))
        } else {
          selectedOptions = q.options.filter((opt) => opt.label === q.answer)
        }

        return {
          ...q,
          options: q.options.map((opt) => {
            const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

            if (linkedQuestions?.length) {
              const isSelectedOption = selectedOptions.some((selected) => selected.label === opt.label)
              if (isSelectedOption) {
                return {
                  ...opt,
                  linkedQuestion: updateAnswerById(linkedQuestions, targetId, updater),
                }
              }
            }
            return opt
          }),
        }
      }

      return q
    })
  }
  const renderQuestion = (item, parentKey, parentIdx, parentPath = []) => {
    const currentPath = [...parentPath, item.id]
    const isTopLevel = parentPath.length === 0
    return (
      <div key={item.id} className="mb-3">
        <div className="d-flex align-items-center gap-1 mb-2">
          <p className="mb-0">{parentIdx + 1}.</p>
          <CFormLabel className="mb-0">{item.label}</CFormLabel>
        </div>
        {item.type === 'dropdown' && (
          <Select
            isMulti={item?.isMultiple}
            menuIsOpen={item?.isMultiple ? undefined : item?.menuIsOpen}
            closeMenuOnSelect={!item?.isMultiple}
            styles={{
              control: (base, state) => ({
                ...base,
                backgroundColor: '#191919',
                borderColor: state.isFocused ? '#989898' : '#989898',
                borderWidth: '0.6px',
                borderRadius: '6px',
                boxShadow: 'none',
                '&:hover': {
                  borderColor: '#989898',
                },
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: '#000',
                borderRadius: '6px',
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? '#191919' // blue for selected
                  : state.isFocused
                    ? '#2a2a2a'
                    : '#000',
                color: 'white',
                cursor: 'pointer',
                padding: '12px 14px',
                borderBottom: '1px solid #333',
                ':last-of-type': {
                  borderBottom: 'none',
                },
                ':active': {
                  backgroundColor: '#2a2a2a',
                },
              }),
              multiValue: (base) => ({
                ...base,
                backgroundColor: '#191919',
                borderRadius: '4px',
                border: '1px solid #454545ff',
              }),
              multiValueLabel: (base) => ({
                ...base,
                color: 'white',
              }),
              multiValueRemove: (base) => ({
                ...base,
                color: 'white',
                ':hover': {
                  backgroundColor: '#333',
                  color: 'white',
                },
              }),
              singleValue: (base) => ({
                ...base,
                color: 'white',
              }),
              placeholder: (base) => ({
                ...base,
                color: '#aaa',
              }),

              input: (base) => ({
                ...base,
                color: 'white',
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: 'white',
                ':hover': { color: 'white' },
              }),
            }}
            onChange={(selected) => {
              let selectedValues = ''
              let selectedValuesArr = []
              if (item?.isMultiple) {
                selectedValuesArr = selected?.map((opt) => opt.value) || []
                selectedValues = selectedValuesArr.join(', ')
              } else {
                selectedValues = selected?.value || ''
              }

              setQuestionsWithDiagnosis((prevData) => {
                const newData = { ...prevData }
                newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, answer: selectedValues }))
                return newData
              })
            }}
            value={
              item?.isMultiple
                ? item?.answer && item.answer.trim()
                  ? item.answer.split(',').map((val) => ({
                      value: val.trim(),
                      label: val.trim(),
                    }))
                  : []
                : item?.answer && item.answer.trim()
                  ? { value: item.answer, label: item.answer }
                  : null
            }
            options={
              item.options?.map((opt) => ({
                value: opt.label,
                label: opt.label,
              })) || []
            }
            placeholder="Select an option"
            isClearable={!item?.isMultiple}
          />
        )}
        {item.type === 'input' && (
          <input
            type="text"
            className="form-control mt-2 "
            value={item.answer || ''}
            style={{
              backgroundColor: '#191919',
              color: 'white',
              border: '0.6px solid #989898',
            }}
            onChange={(e) => {
              const val = e.target.value
              setQuestionsWithDiagnosis((prevData) => {
                const newData = { ...prevData }
                newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, answer: val }))
                return newData
              })
            }}
            placeholder="Enter your text"
          />
        )}
        {item.providerInfo && (
          <p className="  mt-2" style={{ color: 'yellow' }}>
            {item.providerInfo}
          </p>
        )}
        {item.options?.map((opt) => {
          let isSelected = false
          if (item?.isMultiple) {
            const answerArray = item?.answer ? item.answer.split(',').map((v) => v.trim()) : []
            isSelected = answerArray.includes(opt.label)
          } else {
            isSelected = item?.answer === opt.label
          }
          const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

          return (
            isSelected &&
            linkedQuestions?.length > 0 && (
              <div key={`${opt.label}-${item.id}`} className="ml-3 mt-3 border-start ps-3">
                {linkedQuestions.map((nestedItem, nestedIdx) => renderQuestion(nestedItem, parentKey, nestedIdx, currentPath))}
              </div>
            )
          )
        })}
        {isTopLevel && (
          <div className="mt-2">
            <Graytextarea
              value={item.freeType || ''}
              onChange={(e) => {
                const val = e.target.value
                setQuestionsWithDiagnosis((prevData) => {
                  const newData = { ...prevData }
                  newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, freeType: val }))
                  return newData
                })
              }}
              style={{
                border: '0.6px solid #989898',
                background: '#191919',
                height: '100px',
                color: 'white',
                fontSize: '14px',
              }}
              placeholder="Freetype"
            />
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <CAccordion activeItemKey={2}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center justify-content-between gap-2">
              <p class="m-0 p-0 font-weight-medium text-capitalize" style={{ fontSize: '1rem' }}>
                {patientData?.Status === 'Follow Up' ? 'Subjective' : 'HPI'}
              </p>
              {isAllotedToProvider && (
                <CFormLabel
                  className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setVisible((p) => !p)
                  }}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: '#4363F2',
                    cursor: 'pointer',
                  }}
                >
                  <Plus className="text-white" strokeWidth={2} size={15} />
                </CFormLabel>
              )}
              <CFormLabel
                className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setFreetypeModal((p) => !p)
                }}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: '#4363F2',
                  cursor: 'pointer',
                }}
              >
                <FilePlus2 className="text-white" strokeWidth={2} size={15} />
              </CFormLabel>
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            <div className="d-flex  flex-column gap-2 ">
              {patientData?.Status === 'Follow Up' && subjective[noteID]?.medicationRemarksForSubjective && (
                <div>
                  <Graytextarea value={subjective[noteID]?.medicationRemarksForSubjective} height={'100px'} />
                </div>
              )}

              {/* <div>
                <CAccordion flush className="mt-2">
                    {diagnosis?.map((item, index) => (
                        item !== "" && item !== undefined && (
                            <CAccordionItem key={index} itemKey={index} onClick={() => { handleSelectAccordian(item) }}>
                                <CAccordionHeader>{item}</CAccordionHeader>
                                {fetchedQuestions.questionData && (
                                    <CAccordionBody>
                                        <div className="bg-white d-flex flex-column gap-4">
                                            <DisplayNoteHpiQuestion fetchedQuestions={fetchedQuestions} />
                                        </div>
                                    </CAccordionBody>
                                )}
                            </CAccordionItem>
                        )
                    ))}
                </CAccordion>

               </div> */}
              <div className="">
                {!fetchingQuestions ? (
                  <div className="d-flex flex-column gap-2">
                    {newFreeTypeText && <p style={{ color: 'gray' }}>{newFreeTypeText || ''}</p>}
                    {Object.entries(questionsWithDiagnosis)
                      //   .filter(([key, value]) => !(value[0]?.isOptionForFreeType)) // <-- skip if true
                      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
                      .map(([key, value], index) => {
                        return (
                          <CAccordion key={index} alwaysOpen>
                            <CAccordionItem itemKey={1}>
                              <CAccordionHeader>
                                <div className="d-flex justify-content-between align-items-center gap-2 w-100">
                                  <p className="p-0 m-0">{key}</p>
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      e.preventDefault()
                                      if (value.length > 0 && value[0]?.freewayRemark) {
                                        setFreeTypeRemarksText(value[0]?.freewayRemark)
                                      }
                                      setSelectedDiagnosiToAddFreeTypeRemarks(key)
                                    }}
                                    className="mr"
                                    style={{
                                      marginRight: '10px',
                                    }}
                                  >
                                    {' '}
                                    <FilePlus2 size={18} />{' '}
                                  </span>
                                </div>
                              </CAccordionHeader>
                              <CAccordionBody className="" style={{ border: '0.6px solid #989898', borderRadius: '10px' }}>
                                {freeTypes[key] && <p style={{ whiteSpace: 'pre-wrap' }}>{freeTypes[key]}</p>}

                                {value.filter((item) => !item?.isOptionForFreeType).map((item, idx) => renderQuestion(item, key, idx))}
                              </CAccordionBody>
                            </CAccordionItem>
                          </CAccordion>
                        )
                      })}
                  </div>
                ) : (
                  <p>Loading...</p>
                )}
                <div className="d-flex justify-content-center mt-2">
                  <CButton
                    onClick={handleSubmit2}
                    style={{
                      backgroundColor: '#3F65F6',
                      padding: '5px !important',
                      width: '85px',
                      height: '40px',
                      borderRadius: '12px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: 'white',
                    }}
                  >
                    {saving ? 'Saving...' : 'Save'}
                  </CButton>
                </div>
              </div>
              {/* <div >
                                <div style={{
                                    // preserve line breaks and spaces
                                    // border: '1px solid #ccc',
                                    borderRadius: '10px',
                                    padding: '8px',
                                    fontSize: '16px',
                                    fontFamily: 'Plus Jakarta Sans',
                                    color: '#2c384af2',
                                    minHeight: '120px',
                                    // overflowY: 'auto',

                                    backgroundColor: '#8080800d',
                                }} dangerouslySetInnerHTML={{ __html: hpiNotes }} />
                            </div> */}

              <div>{subjective[noteID]?.data || ''}</div>
              {/* {patientData?.Status === 'Follow Up'  && subjective[noteID]?.data && <div>
                            </div>} */}
            </div>
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      {/* 
      <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add HPI Questions</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ minHeight: '60vh', overflowY: 'auto' }} className="d-flex flex-column gap-2 h-75">
          <div>
            <CFormLabel>Select Diagnosis</CFormLabel>
            <Select
              isMulti
              onChange={(e) => {
                setSelectedDiagnosis(e)
              }}
              options={diagnosisData}
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" onClick={() => setVisible(false)} color="secondary">
            Close
          </CButton>
          <CButton variant="outline" onClick={handleAddDiagnosis}>
            {isAddingDiagnosis ? 'Adding...' : 'Add Diagnosis'}
          </CButton>
        </CModalFooter>
      </CModal> */}
      <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
            id="LiveDemoExampleLabel"
          >
            Add Diagnosis
          </CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            minHeight: '50vh',
            overflowY: 'auto',
            backgroundColor: '#282828',
            color: 'white',
          }}
          className="d-flex flex-column gap-2 "
        >
          <div>
            <CFormLabel style={{ color: 'white' }}>Select Diagnosis</CFormLabel>
            <Select
              isMulti
              onChange={(e) => {
                setSelectedDiagnosis(e)
              }}
              options={diagnosisData}
              styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: '#191919',
                  borderColor: state.isFocused ? '#444' : '#444',
                  borderRadius: '6px',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: '#444',
                  },
                }),
                menu: (base) => ({
                  ...base,
                  backgroundColor: '#000',
                  borderRadius: '6px',
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? '#191919' // blue for selected
                    : state.isFocused
                      ? '#2a2a2a'
                      : '#000',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '12px 14px',
                  borderBottom: '1px solid #333',
                  ':last-of-type': {
                    borderBottom: 'none',
                  },
                  ':active': {
                    backgroundColor: '#2a2a2a',
                  },
                }),
                multiValue: (base) => ({
                  ...base,
                  backgroundColor: '#191919',
                  borderRadius: '4px',
                  border: '1px solid #454545ff',
                }),
                multiValueLabel: (base) => ({
                  ...base,
                  color: 'white',
                }),
                multiValueRemove: (base) => ({
                  ...base,
                  color: 'white',
                  ':hover': {
                    backgroundColor: '#333',
                    color: 'white',
                  },
                }),
                singleValue: (base) => ({
                  ...base,
                  color: 'white',
                }),
                placeholder: (base) => ({
                  ...base,
                  color: '#aaa',
                }),

                input: (base) => ({
                  ...base,
                  color: 'white',
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: 'white',
                  ':hover': { color: 'white' },
                }),
              }}
            />
          </div>
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            paddingTop: '10px',
          }}
        >
          <CButton
            onClick={handleAddDiagnosis}
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            {isAddingDiagnosis ? 'Adding...' : 'Add Diagnosis'}
          </CButton>
          <CButton
            onClick={() => setVisible(false)}
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal
        className=""
        centered
        visible={selectedDiagnosiToAddFreeTypeRemarks !== ''}
        size="lg"
        alignment="center"
        onClose={() => {
          setSelectedDiagnosiToAddFreeTypeRemarks('')
        }}
      >
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
              fontSize: '16px',
            }}
            id="LiveDemoExampleLabel"
          >
            Add Free remarks to {selectedDiagnosiToAddFreeTypeRemarks ? selectedDiagnosiToAddFreeTypeRemarks : ''}
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            overflowY: 'auto',
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <div>
            <Graytextarea
              value={freeTypeRemarksText}
              onChange={(e) => {
                setFreeTypeRemarksText(e.target.value)
              }}
              style={{
                backgroundColor: '#282828',
                color: 'white',
                border: '1px solid #989898',
                height: '200px',
              }}
            />
          </div>
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            paddingTop: '10px',
          }}
        >
          {/* <CButton variant="outline" onClick={() => {
                        setFreeTypes(prev => ({
                            ...prev,
                            [selectedDiagnosiToAddFreeTypeRemarks]: freeTypeRemarksText
                        }))

                        setSelectedDiagnosiToAddFreeTypeRemarks("");
                        setFreeTypeRemarksText("");
                        setQuestionsWithDiagnosis(prevData => {
                            const newData = { ...prevData };
                            if (newData[selectedDiagnosiToAddFreeTypeRemarks]) {
                                newData[selectedDiagnosiToAddFreeTypeRemarks].[0]?.freewayRemark = freeTypeRemarksText;
                            }
                            return newData;
                        })
                    }}>Save</CButton> */}
          <CButton
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => {
              setFreeTypes((prev) => ({
                ...prev,
                [selectedDiagnosiToAddFreeTypeRemarks]: freeTypeRemarksText,
              }))

              setSelectedDiagnosiToAddFreeTypeRemarks('')
              setFreeTypeRemarksText('')

              setQuestionsWithDiagnosis((prevData) => {
                const newData = { ...prevData }

                if (!Array.isArray(newData[selectedDiagnosiToAddFreeTypeRemarks])) {
                  newData[selectedDiagnosiToAddFreeTypeRemarks] = []
                }

                if (newData[selectedDiagnosiToAddFreeTypeRemarks].length > 0) {
                  newData[selectedDiagnosiToAddFreeTypeRemarks][0].freewayRemark = freeTypeRemarksText
                } else {
                  // Create default object based on your shared structure
                  newData[selectedDiagnosiToAddFreeTypeRemarks].push({
                    id: Date.now(),
                    label: '',
                    answer: '',
                    condition: null,
                    type: 'text',
                    isMultiple: false,
                    toolTipValue: '',
                    options: [],
                    freeType: '',
                    showFreeTypeInAssessment: false,
                    freewayRemark: freeTypeRemarksText,
                    isOptionForFreeType: true,
                  })
                }

                return newData
              })
            }}
          >
            Save
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => {
              ;(setVisible(false), setSelectedDiagnosiToAddFreeTypeRemarks(''))
            }}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      {/* <CModal
        visible={freetypeModal}
        size="lg"
        onClose={() => {
          setFreetypeModal(false)
        }}
      >
        <CModalHeader>
          <CModalTitle>Add Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea placeholder="Enter freetype" value={tempFreeTypeText} rows={4} onChange={(e) => setTempFreeTypeText(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            variant="outline"
            onClick={() => {
              setFreetypeModal(false)
              setTempFreeTypeText('')
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            variant="outline"
            onClick={() => {
              setFreetypeModal(false)
              setNewFreeTypeText(tempFreeTypeText)
            }}
            // onClick={() => {
            //     const textToBeAddInDiagnosis = allIncidents[currentIncidentIndex]
            //     if(textToBeAddInDiagnosis && textToBeAddInDiagnosis?.incidents && textToBeAddInDiagnosis?.incidents.length > 0){

            //     }else{
            //         toast.error("no incident there to add in index",toastConfig)
            //     }
            // }}
          >
            Add
          </CButton>
        </CModalFooter>
      </CModal> */}
      {/*dark mode  new */}
      <CModal visible={freetypeModal} size="lg" alignment="center" onClose={() => setFreetypeModal(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CModalTitle style={{ color: 'white', width: '100%' }}>Add Freetype</CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea
            placeholder="Enter freetype"
            value={tempFreeTypeText}
            rows={4}
            onChange={(e) => setTempFreeTypeText(e.target.value)}
            style={{
              backgroundColor: '#191919',
              color: 'white',
              border: '1px solid #444',
              height: '200px',
            }}
          />
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
          }}
        >
          <CButton
            onClick={() => {
              setFreetypeModal(false)
              setNewFreeTypeText(tempFreeTypeText)
            }}
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            Add
          </CButton>
          <CButton
            onClick={() => {
              setFreetypeModal(false)
              setTempFreeTypeText('')
            }}
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderHpiQuestions
